const radii = {
  none: '0',
  small: '3px',
  medium: '6px',
  large: '9px',
  huge: '50%',
}

export default radii
